// extracted by css-extract-rspack-plugin
export default {"root":"root-QRs5ur","detailBodyMain":"detailBodyMain-qxyhtW","leftCol":"leftCol-xZ3FOQ","rightCol":"rightCol-Dpp91N"};